import { CustomRadioGroup } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useAppSelector, useDictionary } from 'Hooks';
import { IndexContext } from 'Modules/CaseDetails/CaseContext';
import { useContext } from 'react';
import { useWatch } from 'react-hook-form';
import { UnknownWitnesses } from './UnknownWitnesses';
import { KnownWitnesses } from './KnownWitnesses';

export const KNOWN_WITNESSES_ID = 1;
export const UNKNOWN_WITNESSES_ID = 2;

export const Witnesses = () => {
  const { index } = useContext(IndexContext);

  const [areThereWitnessesOptions] = useAppSelector(
    ({
      generalContent: {
        generalContent: { areThereWitnessesOptions },
      },
    }) => [areThereWitnessesOptions]
  );

  const dictionary = useDictionary(Dictionary, DICTIONARY.CASE_DETAILS);

  const baseName = `caseDetails.${index}`;

  const [areThereWitnessesOptionId] = useWatch({
    name: [`${baseName}.areThereWitnessesOptionId`],
  });

  return (
    <>
      <CustomRadioGroup
        id={dictionary.fourthSectionWitnessQ}
        name={`${baseName}.areThereWitnessesOptionId` as const}
        options={areThereWitnessesOptions.map(({ id, value }) => ({
          value: id.toString(),
          label: value,
        }))}
      />
      {areThereWitnessesOptionId == KNOWN_WITNESSES_ID && <KnownWitnesses />}
      {areThereWitnessesOptionId == UNKNOWN_WITNESSES_ID && (
        <UnknownWitnesses />
      )}
    </>
  );
};
